export const styles = (theme) => ({
  container: {
    marginBottom: 200
  },
  side: {
    marginTop: -46,
    width: theme.sizes.sideColumn
  },
  content: {
    width: 720
  }
});
